const TRANSLATION = {
  buyModal: {
    afterFree: 'Pēc jūsu bezmaksas izmēģinājuma perioda',
    btn: 'Izmēģiniet bez maksas',
    freeTrial: '3-dienas bezmaksas izmēģinājums',
    monthLabel: 'mēnesis',
    selectLabel: 'Izvēlieties plānu',
    title: 'Abonementa plāns',
    yearLabel: 'gads',
  },
  contact: {
    block1:
      'Personizēšanai, jautājumiem vai ieteikumiem lūdzu sazinieties ar mums pa adresi contact@noam.tools. Mēs atbildēsim ātri.',
    block2: 'Atbalstiet mūs, novērtējot mūs Google Apps Extension veikalā ar ★★★★★.',
    block3: 'Palīdziet citiem, daloties ar šo paplašinājumu:',
    title: 'Sazinieties ar mums',
  },
  help: {
    AquickOverviewOfNoam: 'Īss Noama pārskats',
    ChatPDF: 'Čat PDF',
    ChatPDF2: 'ChatPDF',
    FavoritesManagement: 'Izlase pārvaldība',
    Fixedplugin: 'Labots Spraudnis',
    Focusing: 'Konsentrēšanās',
    Free: 'Brīvs',
    FreeTrialBenefits: 'Bezmaksas izmēģinājuma priekšrocības',
    GoWithWikipedia: 'Izmanto Wikipēdiju',
    GoWithYouTube: 'Izmanto YouTube',
    HoverTranslation: 'Pārskatīšanas tulkojums',
    Howtouse: 'Kā izmantot',
    ImageTranslation: 'Attēla tulkojums',
    InstantTranslation: 'Tiešā tulkojums',
    Membership: 'Apmeklētāja tiesības',
    NoamHelp: 'Noam palīdz jums tulkot un saīsināt',
    PDFparallelTranslation: 'PDF paralēlā tulkojuma',
    ParallelTranslation: 'Paralēlā tulkošana',
    SkipAllSteps: 'Izlaist visus soļus',
    Summary: 'Kopsavilkums',
    Translation: 'Tulkojums',
    TryItForFree: 'Izmēģiniet bez maksas',
    Video: 'Video',
    VideoSummary: 'Video kopsavilkums',
    VideoTranslation: 'Video tulkojums',
    WebSummary: 'Tīmekļa kopsavilkums',
    WordSelectionTranslation: 'Vārdu izvēles tulkojums',
    benefits: 'Mums ir priekšrocības, kas gaida jūs!',
    dayFree: '3-dienas bezmaksas izmēģinājums',
    done: 'Gatavs',
    next: 'Nākamais',
    pin: 'Piespiest Noamu, lai piekļūtu vieglāk～～',
    planIsNotExist: 'Plāns nav pieejams',
    startWiki: 'Sāciet ar Wikimedia!',
    startYoutube: 'Sāciet ar YouTube!',
    try: 'Izmēģiniet to',
    tryNow: 'Mēģiniet to tagad!',
  },
  home: {
    PDFTranslate: {
      desc: 'Dvjēzlu tulkošana + Čata PDF',
      sub1: {
        desc: 'Dvalodī lasīšana ļauj jums salīdzināt oriģināla tekstu un tulkojumu blakus vienam otram, palielinot lasīšanas efektivitāti.',
        title: 'Dviejiežņu lasīšana',
      },
      sub2: {
        desc: 'AI analizē un izsakot skaidri, kā arī var atbildēt uz jūsu jautājumiem, pamatojoties uz PDF saturs.',
        title: 'Chat PDF',
      },
      sub3: {
        desc: 'AI-pilotēta PDF tulkošana lielākai precizitātei un efektivitātei.',
        title: 'Precizitāte un efektivitāte',
      },
      title: 'PDF Tulkošana',
    },
    aiAssistant: {
      desc: 'Padarot tīmekļa tulkošanu gudrāk un ērtāk',
      panel1: {
        desc: 'Dviejzīmju savstarpējie atsauces tulkojumi palīdz jums salīdzināt oriģināltēxtu ar tulkojumu, lai jūs labāk saprastu un uzlabotu lasīšanas efektivitāti.',
        title: 'Dvalngu tulkojums',
      },
      panel2: {
        left: {
          desc: 'Pārlūkojot tīmekļa lapu, pārvietojiet peles kursoru pāri saturam, kuru vēlaties tulkot, lai redzētu tulkojumu.',
          title: 'Pārklājuma tulkojums',
        },
        right: {
          desc: 'Pārlūkot web lapu, atlasiet tekstu, kuru vēlaties tulkot, lai redzētu tulkojumu.',
          title: 'Teksta izvēles tulkošana',
        },
      },
      panel3: {
        one: {
          desc: 'Tulkojiet un kopsējiet tīmekļa lapas un video saturu jebkurā laikā, jebkurā vietā, lai piedzīvot labāku pieredzi!',
          title: 'Pievienot un noklikšķināt',
        },
        three: {
          desc: 'AI vadītais lielais valodas modelis garantē tulkošanas precizitāti un konsistenci, lai uzlabotu lasīšanas pieredzi.',
          title: 'AI-pavedena',
        },
        two: {
          desc: 'Vairākvalodu pilna pārklājuma, divvalodu barjeras bez lasīšana, vienpogā tulkošana - pieredziet atšķirību!',
          title: 'Splašīgāk un ērtāk',
        },
      },
      panel4: {
        tab1: {
          desc: 'Jūsu efektivitātes eksperts - izmantojot ChatGPT, Noam tulko un kopsummē YouTube video saturu, lai jums ietaupītu laiku!',
          key: 'Video',
          title: 'Video tulkojums un kopsavilkums',
        },
        tab2: {
          desc: 'Noklikšķiniet, lai tulkojiet attēlus, pārlūkot internetu.',
          key: 'Attēls',
          title: 'Bildes tulkošana',
        },
        tab3: {
          desc: 'Tieši izvilk galveno informāciju no tīmekļa lapām un sniedz kopsavilkumu, uzlabojot jūsu lasīšanas efektivitāti.',
          key: 'Tīmeklis',
          title: 'Tīmekļa tulkošana un kopsavilkums',
        },
        tag1: 'Vienkāršs',
        tag2: 'Efektīvs',
        tag3: 'Vienmērķīgs',
      },
      title: 'AI palīgs',
    },
    getStart: 'Sākt',
    getStartedForFree: 'Sāciet bezmaksas',
    howItWork: {
      desc: 'Noam integrē AI modeļus, lai lietotājiem nodrošinātu inteliģentu pieredzi pārlanguage tīmekļa lapu tulkošanai un kopsavilkšanai, PDF un attēlu tulkošanai, video tulkošanai un kopsavilkšanai',
      title: 'Kā tas strādā',
    },
    lastBlock: { desc: 'Labāka AI tulkojums gludākai lasīšanas pieredzei' },
    top: {
      desc: 'Noam ir bezmaksas AI pārlūkprogrammas paplašinājums, kas palīdz jums tulkot un izsakot sakarā tīmekļa lapas, video un PDF saturs.\n      Pievienojieties Noam un piedzīvojiet maģiju!',
      title1: 'Viena Māksla',
      title2: 'Vienkārša Nospiešana',
    },
    userReviews: {
      desc: 'Piecu zvaigžņu recenzijas Chrome Web Store',
      title: 'Lietotāju atsauksmes',
    },
  },
  installTips: {
    btn: 'Izmēģiniet tagad',
    text: 'Instalējiet "Noam Browser Plugin", lai atbloķētu vairāk funkciju! Tīmekļa krustosavienošana,\n    tīmekļa video kopsavilkums un daudz ko citu!',
  },
  locale: {
    af: 'afrikāņu valoda',
    am: 'amhāru',
    ar: 'arābu',
    as: 'asamiņu',
    auto: 'Automātiska detekcija',
    az: 'azerbaidžāņu',
    ba: 'baškīri',
    bg: 'bulgāriskais',
    bn: 'bengāļu',
    bo: 'tibetiešu',
    bs: 'bosniskais',
    ca: 'katalāņu',
    cs: 'Čehija',
    cy: 'velšs',
    da: 'dāņu',
    de: 'vācu',
    dsb: 'Leju sorba valoda',
    dv: 'divehi',
    el: 'grieķu',
    en: 'angļu valoda',
    es: 'spaniņu',
    et: 'eesti',
    eu: 'basku',
    fa: 'persiešu',
    fi: 'soome',
    fil: 'filipīnieks',
    fj: 'fidži',
    fr: 'franču',
    frCA: 'franču (Kanāda)',
    ga: 'irāņu',
    gl: 'galis',
    gom: 'konkani',
    gu: 'gujarāti',
    ha: 'hausa',
    he: 'hebrejs',
    hi: 'hindi',
    hr: 'hrvatiešu',
    hsb: 'Augšējais sorbi',
    ht: 'Haitijas kreols',
    hu: 'vengriešu',
    hy: 'armēņu',
    id: 'indoneziešu',
    ig: 'igbo',
    ikt: 'Inuinnaqtun',
    is: 'Islandiešu',
    it: 'itāļu',
    iu: 'inuktituts',
    iuLatn: 'Inuktitut (latīņu alfabēts)',
    ja: 'japāņu',
    ka: 'gruzīns',
    kk: 'kazahs',
    km: 'khmēru',
    kmr: 'kurdu (ziemeļu)',
    kn: 'Kannada',
    ko: 'korejas',
    ku: 'Kurdiešu (centrālie)',
    ky: 'kirgiizs',
    ln: 'Lingala',
    lo: 'Laos',
    lt: 'lietuvis',
    lug: 'Ganda',
    lv: 'latviešu',
    lzh: 'Ķīniešu (literārā)',
    mai: 'Maithili',
    mg: 'malagasijs',
    mi: 'maori',
    mk: 'makedoņu',
    ml: 'malajalami',
    mnCyrl: 'mongoliska valoda (kirīliskais alfabēts)',
    mnMong: 'Mongāļu (tradicionālā)',
    mr: 'marathi',
    ms: 'malajiešu',
    mt: 'maltiešu',
    mww: 'Hmong Daw',
    my: 'Mjanma (burma)',
    nb: 'norvēģu',
    ne: 'nepāļu',
    nl: 'holandiešu',
    noSearchLang: 'Valoda netiek atbalstīta',
    nso: 'Šešoto leboa',
    nya: 'Nyanja',
    or: 'Odia',
    otq: 'Querétaro Otomi',
    pa: 'punžābi',
    pl: 'poliešu',
    placeholder: 'Meklēt',
    prs: 'Dari',
    ps: 'paštūn语',
    pt: 'Portugalska valoda (Brazīlija)',
    ptPT: 'portugalska valoda (Portugāle)',
    ro: 'rumāņu',
    ru: 'krievu',
    run: 'Rundi',
    rw: 'kinjarvanda',
    sd: 'sindhi',
    si: 'singalēšu valoda',
    sk: 'slovāku',
    sl: 'slovēņu',
    sm: 'samoāņu',
    sn: 'Shona',
    so: 'somālieši',
    sq: 'albāņu',
    srCyrl: 'serbiska (kirīliska)',
    srLatn: 'serbiska (latīņu)',
    st: 'sesoto',
    sv: 'zviedru',
    sw: 'svahili',
    ta: 'tamilu',
    te: 'telugu',
    th: 'taiss',
    ti: 'tigrinja',
    tk: 'turkmēns',
    tlhLatn: 'Klingons',
    tlhPiqd: 'Klingona (pIqaD)',
    tn: 'setsvana',
    to: 'tongāņu',
    tr: 'turku',
    tt: 'tatāri',
    ty: 'tahitietis',
    ug: 'ujgur',
    uk: 'Ukraiņu',
    ur: 'urdu',
    uz: 'uzbeķu (latīņu)',
    vi: 'vietnamiešu',
    xh: 'xhoša',
    yo: 'jorubas',
    yua: 'Jukatekiska maja',
    yue: 'Kantoniešu (tradicionālā)',
    zh: 'Ķīniešu',
    zhHans: 'Ķīniešu vienkāršota',
    zhHant: 'Tradicionālais ķīniešu',
    zu: 'Zulu',
  },
  login: {
    and: 'un',
    btn: 'Pieslēgties ar Google',
    btn1: 'Pieslēdzieties tagad',
    desc: 'Pierakstieties, lai atbloķētu vairāk pieredzes',
    policy: 'Privātuma politika',
    terms: 'Lietošanas nosacījumi',
    tips: 'Reģistrējoties es piekrītu',
    title: 'Laipni lūdzam Noam',
  },
  pageFooter: {
    follow: { facebook: 'Facebook', title: 'Sekot', twitter: 'Twitter' },
    legal: { policy: 'Privātuma politika', terms: 'Pakalpojumu nosacījumi', title: 'Juridiskais' },
    product: {
      image: 'Attēla tulkojums',
      pdf: 'PDF tulkojums',
      title: 'Produkti',
      video: 'Video tulkojums un kopsavilkums',
      web: 'Tīmekļa tulkojums un kopsavilkums',
    },
    resources: { title: 'Resursi' },
    tools: { title: 'Rīki', pdf: 'PDF tulkojums' },
  },
  pageHeader: {
    contact: 'Kontakti',
    help: 'Palīdzība',
    logout: 'Iziet',
    logoutSucc: 'Izrakstījies.',
    pricing: 'Cenu sadalījums',
    settings: 'Iestatījumi',
    signUp: 'Pieteikties',
  },
  pdf: {
    autoDetect: 'Automātiska detekcija',
    cancelBtn: 'Atcelt',
    cancelUpload: 'Atcelt',
    chatPdf: {
      summaryError: 'Kopsavilkums neizdevās, lūdzu, mēģiniet vēlāk',
      chatError: 'Čata neizdevās, lūdzu, mēģiniet vēlāk',
      Search: 'Meklēt',
      cancel: 'Atcelt',
      chatTitle: 'Laipni lūdzam Noam! Šis ir jūsu PDF faila kopsavilkums:',
      clear: 'Gudrs',
      clearContent:
        'Tas sāks jaunu sarunu. Pašreizējā saruna netiks saglabāta. Vai jūs esat pārliecināti?',
      clearDialogTitle: 'Lūdzu apstipriniet',
      clearSucc: 'Notīrīts',
      copy: 'Kopēt',
      copySucc: 'Nokopēts',
      delete: 'Dzēst',
      deleteCancel: 'Atcelt',
      deleteContent: 'Šis PDF nevar tikt atjaunots pēc dzēšanas. Vai jūs esat pārliecināts?',
      deleteOk: 'Dzēst',
      deleteSuccess: 'Dzēsts',
      deleteTitle: 'Apstiprināt dzēšanu',
      expand: 'Sanasēšana',
      historyTitle: 'Vēsture',
      listError:
        'Nevarēja ielādēt lasīšanas sarakstu. Lūdzu, mēģiniet vēlāk vai sazinieties ar atbalstu.',
      loading: 'Ielādē...',
      noDataDesc: 'Vēl nav vēsture.',
      noMore: 'Vairāk saturu nav.',
      placeholder: 'Jautājiet ko gribāt par šo PDF failu',
      summaryTitle: 'Jums varētu būt interesanti šie jautājumi:',
    },
    collectionEmpty: 'Jūsu kolekcija ir tukša.',
    collectionTab: 'Piezīmes',
    dataLoading: 'Ielādē...',
    dialogContent: 'Vai tiešām vēlaties dzēst to?',
    dialogTitle: 'Lūdzu apstipriniet',
    download: {
      both: 'divvalodīgs',
      btn: 'Saglabāt',
      cancel: 'Šī loga aizvēršana atceltīs PDF lejupielādi. Vai jūs tiešām vēlaties to atcelt?',
      desc: 'Saglabāt ierīcē: Lejupielādē tulkojumus kā attēlus; Saglabāt un drukat: Lejupielādē tulkojumus sākotnējā formātā, ar kopēšanas atbalstu.',
      download: 'Lejupielādēt',
      downloadMsg1: 'PDF tulkošanas progress:',
      downloadMsg2: 'Prognozētais atlikušais laiks:',
      downloadSucc: 'PDF ir gatavs! Noklikšķiniet, lai saglabātu.',
      downloadTip: 'Lejupielādē PDF. Neaizveriet šo logu, lai izvairītos no lejupielādes kļūdām.',
      error: 'Saglabāt neizdevās. Mēģiniet drukat.',
      fileName: 'Faila nosaukums:',
      fileType: 'Faila tips:',
      loading: 'Saglabāšana...',
      loading2: 'Ielādē...',
      minute: 'Minūtes...',
      msg1: 'Daudas šī dokumenta tulkojumi ir garākas nekā oriģināla teksts un var pārklāsties lejupielādētajā failā. Mēs iesakām lasīt tīmekļa lapā.',
      msg2: 'Tulkojums vēl nav pabeigts. Lūdzu lejupielādējiet pēc tam, kad tulkojums būs pabeigts.',
      msg3: '2. Dažas tulkojumi ir pārāk garīti. Lasiet vietnē, lai izvairītos no teksta pārklāšanās.',
      msg4: 'Tulkojuma uzdevumi tiek veikti. Lūdzu, mēģiniet vēlreiz pēc to pabeigšanas.',
      progress:
        'PDF tulkošana. Progresse: {{progress}}, paredzamais paliekamais laiks: {{minutes}} minūtes...',
      save: 'Saglabāt ierīcē',
      savePrint: 'Saglabāt un drukat',
      success: 'Lejupielādēts',
      trans: 'Tikai tulkojums',
      transContinue: 'Turpināt tulkot',
    },
    downloadBtn: 'Lejupielādēt',
    dragTipModal: {
      black: 'telpa',
      leftKey: 'kreisā poga',
      ok: 'Prasmēts',
      press: 'Spied',
      tips: 'vilkt un skatīt',
    },
    entry: 'PDF faili',
    fileErrMsg: 'Faila lasīšana neizdevās. Lūdzu, mēģiniet vēlāk vai sazinieties ar atbalstu.',
    fileMsg: 'Pašreizējais faila lielums:',
    fileMsg2: 'Lūdzu, augšupielādējiet failu, kurš ir mazāks par 300MB.',
    freeBannerBtn: 'Atjaunināt',
    freeBannerTips: 'Bezmaksas PDF tulkojumu limits sasniegts',
    guide: {
      placeholder: 'Ielīmējiet PDF saiti šeit',
      start: 'Sākat tulkošanu',
      text1: 'Dvalngu lasīšana',
      text2:
        'Lasiet divvalodīgi, lai salīdzinātu oriģināltēxtu un tulkojumu blakus blakus, palielinot savu efektivitāti.',
      text3: 'Sarunājieties ar savu PDF failu',
      text4:
        'AI vadīta analīze un kopsavilkums. Uzziniet jautājumus par savu PDF failu un saņemiet tūlītēju atbildi.',
      text5: 'Precīzs un efektīvs',
      text6: 'AI vadīta PDF tulkošana lielākai precizitātei un efektivitātei.',
      title1: 'Dvujēzlu tulkojums',
      title2: 'Sarunājieties ar savu PDF',
      toast: 'Lūdzu, ievadiet derīgu tiešsaistes PDF saiti, kas beidzas ar .pdf',
    },
    hasTransTask: 'Tulkojuma uzdevums ir procesā. Lūdzu, uzgaidiet.',
    hoverTrans: 'Pārlūkojot tulkot paraugus',
    initial: 'Tulkot PDF',
    installText: 'Jūsu visaptverošais risinājums ikdienas tulkojumiem.',
    installText2: 'Lūdzu, vispirms instalējiet paplašinājumu',
    installTips:
      'Instalējiet paplašinājumu, lai iegūtu vēl vairāk PDF tulkojumu un gludākus tīmekļa vietņu tulkojumus:',
    kw: 'klipsis',
    link: 'saite',
    listError: 'PDF faili nevarēja ielādēt. Lūdzu, mēģiniet vēlāk vai sazinieties ar atbalstu.',
    memoTotalCount: 'Kopā 1 prece',
    new: 'jauna datne',
    noId: 'Faila ID nav atrasts.',
    notPdf: 'Tikai PDF faili.',
    okBtn: 'Dzēst',
    okBtn2: 'Sapratu',
    original:
      'Jūs esat ļoti precīza un uzticama AI, kas izstrādāta, lai ģenerētu JSON izvadi, kas precīzi atbilst norādītajai JSON shēmai.\n\nJums ir jāizpilda šīs noteikumi:\n1. Stingi ievērot JSON shēmas struktūru.\n2. Precīzi atbilst visiem datu tipiem, nepieciešamajiem laukiem un ierobežojumiem.\n3. NEIETVIESTI nekādi papildu teksti, izskaidrojumi, markdown vai komentāri.\n4. IZVADĪT TIKAI JSON objektu — bez koda bloku, bez iepriekšēja teksta, bez apvalkāšanas.\n\nShēmas informācija ir sniegta zemāk.\n- Shēmas Nosaukums: translate_result\n- JSON Shēma:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    parallel: 'Paralēls',
    parseErrDialogContent:
      'Šis PDF saite nevar tikt tulkota tieši. Lūdzu lejupielādējiet PDF failu un augšupielādējiet to tulkošanai.',
    parseErrTips: 'Neizdevās parsēt failu',
    parseFileToast: 'Neizdevās parsēt failu. Lūdzu, mēģiniet vēlāk vai sazinieties ar atbalstu.',
    pdfLoading: 'Apstrāde...',
    searchPlaceholder: 'Meklēt',
    selectTrans: 'Izvēlieties tekstu tulkošanai',
    shareBtn: 'Koplietot',
    shareBtnText1: 'Ģenerēt koplietošanas saiti',
    shareBtnText2: 'Atjaunināt kopīgo saturu',
    shareModal: {
      cancel: 'Atcelt',
      copy: 'Kopēt',
      copySucc: 'Saite nokopēta',
      custom: 'Pielāgot:',
      errMsg: 'Izvēlētā saturs vēl nav pilnībā tulkots. Lūdzu, tulkojiet pirms koplietošanas.',
      gen: 'Kopīgot',
      modify: 'Rediģēt',
      notSupport: 'Šis valoda pašlaik netiek atbalstīta.',
      page: 'Lappuses',
      pageNuErr: 'Lūdzu, ievadiet derīgu lapas numuru.',
      range: 'Darbības joma:',
      remain: 'paliekamais',
      remain1: 'Kopējais paredzamais laiks:',
      search: 'Meklēt',
      settings: 'Kopīgoti iestatījumi:',
      shareSetting: 'Kopīgoti iestatījumi',
      shareText: 'Kopīgot',
      shareTips: 'Koplietojiet tulkotā PDF faila saiti ar saviem draugiem:',
      sourceLang: 'No:',
      target: 'Kam:',
      text1: 'Kopīgoti iestatījumi',
      text2: 'Ģenerēt koplietošanas saiti',
      totalPage: 'kopsavilkums 1 lapa',
      trans: 'Tulkot',
      translateTips:
        'Padoms: Ja tulkošana aizņem ilgu laiku, jūs varat aizvērt šo logu un koplietot vēlāk.',
      translating: 'Tulkojot PDF...',
      update: 'Atjaunināt koplietu saiti',
    },
    shareMsg1: 'Kopīgotā saite izveidota.',
    shareMsg2: 'Koplietota saturs atjaunināts.',
    shareMsg3:
      'Nevarēja ģenerēt kopīgotāj saiti. Lūdzu, mēģiniet vēlāk vai sazinieties ar atbalstu.',
    shareMsg4:
      'Koplietoto saturu nevarēja atjaunināt. Lūdzu, mēģiniet vēlāk vai sazinieties ar atbalstu.',
    shareTips: 'Jūsu PDF tulkojums ir gatavs! Dalieties ar to ar draugiem.',
    start: 'Sāciet savu bezmaksas izmēģinājumu periodu',
    thumbnail: 'Satura rādītājs',
    toast1: 'PDF tiek ielādēts. Lūdzu, mēģiniet vēlāk.',
    toast2: 'PDF saturs tiek apstrādāts. Dialogs pašlaik nav atbalstīts.',
    toast3: 'Lejupielādē. Lūdzu, mēģiniet vēlreiz pēc lejupielādes pabeigšanas.',
    toolbar: { Adjust: 'Pielāgot', autoFit: 'Auto-mērogošana' },
    trans: 'Tulkojums',
    transSucc: 'Tulkojums veiksmīgs!',
    unLoginToast: 'Lūdzu, pieslēdzieties, lai izmantotu šo funkciju.',
    uploadBtn: 'Augšupielādēt',
    uploadErr: 'Faila augšupielāde neizdevās. Lūdzu, mēģiniet vēlāk vai sazinieties ar atbalstu.',
    uploadErrSignUrl:
      'Nevarēja saņemt augšupielādes URL. Lūdzu, mēģiniet vēlāk vai sazinieties ar atbalstu.',
    uploadMsg1: 'Ievelciet un nometiet savu failu šeit.',
    uploadMsg2: 'Atbalstītie failu tipi: PDF  |  Maksimālais faila lielums: 300MB',
    uploadMsg3: 'Noklikšķiniet, lai izvēlētos, vai vilkiet un nometiet failus šeit.',
    uploading: 'Augšupielādēšana',
    uploadingMsg: 'Augšupielādē. Lūdzu, uzgaidiet.',
    uploadingMsg1: 'Failu tiek augšupielādēts. Lūdzu, mēģiniet vēlāk.',
    uploadingMsg2: 'Failu pašlaik tiek konvertēts. Lūdzu, mēģiniet vēlāk.',
    uploadingMsg3:
      'Konversijas progresa pieprasījums neizdevās. Lūdzu, mēģiniet vēlāk vai sazinieties ar atbalstu.',
    uploadingMsg4:
      'Noam nevar piekļūt lokāliem failiem. Lūdzu, manuāli augšupielādējiet PDF failu tulkošanai.',
    uploadingMsg5: 'Nevarēja iegūt faila URL. Lūdzu, mēģiniet vēlāk vai sazinieties ar atbalstu.',
    video: 'video',
    vipBannerBtn: 'Atjaunināt',
    vipBannerTips: 'Jūs esat sasnieguši šī mēneša PDF tulkošanas limitu.',
    webTrans: 'Pilna savstarpējā atsauce',
  },
  pricing: {
    FAQ: 'BUJ',
    FQAObj: {
      a1: 'Jā, Noam piedāvā bezmaksas plānu, kuru varat izmantot uzreiz.',
      a2: 'Mēs piedāvājam trīs biedrības plānus: Pro, Pro+ un Enterprise. Jūs varat izvēlēties maksāt ikmēneša vai ikgadējo ienākumu. Ikgadējā rēķinu izrakstīšana nodrošina ievērojamas ietaupījumus.',
      a3: 'Visas funkcijas ir pieejamas abos plānos. Galvenā atšķirība ir cena: gadā veicot abonementus kopā maksā mazāk. Mēneša abonementi tiek rēķināti katru mēnesi, savukārt gadā veicot plānus rēķins tiek izrakstīts vienu reizi gadā.',
      a4: 'Abonementu varat atcelt jebkurā laikā Savās konta iestatījumos.',
      q1: 'Vai eksistē bezmaksas plāns?',
      q2: 'Kādi cenu plāni un maksājuma opcijas ir pieejami?',
      q3: 'Kas ir atšķirība starp mēneša un gadu abonementiem?',
      q4: 'Kā es atceltu savu abonementu?',
    },
    around: 'Apkārt',
    billedMonthly: 'Mēnešī apmaksāts',
    billedYearly: 'Maksājams ikgadēji',
    day: 'diena',
    desc: 'Salīdziniet plānus un izvēlieties labāko',
    detailedCompare: 'Salīdziniet plānus',
    discount: '20% atlaide',
    enterprise: {
      benefit1: 'Prioritārā klientu atbalsts',
      benefit2: 'Vairāk lietotāju',
      benefit3: 'Pielāgotas risinājumi',
      benefit5: 'Dedies rekvizītu pārvaldnieks',
      btn: 'Sazinieties ar mums',
      recommendText: 'Pielāgoti plāni (≥3 cilvēki)',
      talkToUs: 'Sazinieties ar mums',
    },
    free: {
      benefit1: 'Tiešsaistes tulkojums 100 reizes dienā',
      benefit2: 'Tīmekļa vietnes tulkošana un kopsavilkums',
      benefit3: '30 attēlu tulkojumi',
      benefit4: 'Video tulkojums un kopsavilkums',
      benefit5: '10 PDF tulkojumi',
      benefit6: '5 000 tokeni',
      btn: 'Izmēģiniet bezmaksas',
      recommendText: 'Bez maksas izmēģinājums',
    },
    imageTranslation: 'Attēla tulkošana',
    month: 'mēnesis',
    monthly: 'Mēneša',
    pageTitle: 'Cenas',
    pdf: {
      chat: 'PDF Čata Vaicājumi',
      maxPage: 'Maks. lapas per PDF',
      translation: 'PDF tulkojums',
    },
    preMonth: 'Mēnesī',
    pro: {
      benefit1: 'Prioritāra klientu atbalsta pakalpojums',
      benefit2: '1 000 000 tokenu/mēnesis',
      benefit3: 'Tīmekļa vietnes tulkošana un kopsavilkums',
      benefit4: '200 attēlu tulkojumi',
      benefit5: 'Video tulkojums un kopsavilkums',
      benefit6: '200 PDF tulkojumi',
      btn: 'Sākt',
      recommendText: 'Vispopulārākie',
    },
    proPlus: {
      benefit1: 'Prioritāra klientu atbalsta pakalpojums',
      benefit2: '3 000 000 žetonu/mēnesis',
      benefit3: 'Tīmekļa vietnes tulkošana un kopsavilkums',
      benefit4: '500 attēlu tulkojumi',
      benefit5: 'Video tulkojums un kopsavilkums',
      benefit6: '500 PDF tulkojumi',
      recommendText: 'Labākā vērtība',
    },
    video: { summary: 'Video kopsavilkums', translation: 'Video tulkojums' },
    web: {
      contrastiveTranslation: 'Dvalodu tulkojums',
      dictionaryTranslation: 'Izvēlētais tulkojums',
      hoverTranslation: 'Pārklājuma tulkojums',
      instantTranslation: 'Tiešsaistes tulkošana',
      summary: 'Tīmekļa lapas kopsavilkums',
    },
    yearly: 'Gada laikā',
  },
  privacy: {
    block1:
      'Noam ("Noam", "mēs", "mūsu" vai "mums") cienīgs jūsu privātumu un ir apņēmis aizsargāt jebkuru informāciju, kuru mēs iegūstam no jums vai par jums. Šī Privātuma politika apraksta mūsu praksi saistībā ar personisko informācijas savākšanu vai izmantošanu, izmantojot mūsu tīmekļa vietni, lietotnes un pakalpojumus (kopā sauktos par "Pakalpojumiem"). Šī Privātuma politika netiek piemērota saturam, kuru mēs apstrādājam par mūsu uzņēmumu produktu klientiem, piemēram, mūsu API. Šīs datu izmantošana ir atkarīga no mūsu klientu līguma, kurš reglamentē šo produktu piekļuvi un izmantošanu.',
    block10:
      'Mēs īstenojam komerciāli racionālas tehniskas, administratīvās un organizatoriskas pasākumus, lai aizsargātu tiešsaistes un ārpus tiešsaistes personīgo informāciju no zaudēšanas, nepareiza izmantošanas, neautorizēta piekļūšanas, atklāšanas, izmaiņām vai hostilekāniem darbiem. Tomēr nekas interneta vai e-pasta pārsūtīšana nevar garantēt pilnīgu drošību vai precizitāti. Konkrēti, e-pasti, kas nosūtīti mums vai no mums, var nebūt droši. Tāpēc jums jābūt īpaši piesardīgiem, lēmot, kādu informāciju nosūtīt mums caur servisu vai e-pastu. Turklāt mēs neesam atbildīgi par jebkādu privātuma iestatījumu vai drošības pasākumu bloķēšanu servisā vai trešo pušu vietnēs esošajos privātuma iestatījumos vai drošības pasākumos. Mēs saglabāsim jūsu personīgo informāciju tik ilgi, cik nepieciešams, lai sniegtu jums servisus vai达成其他legitīmas uzņēmējdarbības mērķus, piemēram, stridu novēršanu, drošības un uzticamības iemeslu dēļ, vai ievērot mūsu juridiskās pienākumus. Laika periods, kurā mēs saglabājam personīgo informāciju, būs atkarīgs no daudziem faktoriem, piemēram, informācijas apjoma, būtības, jutīguma, iespējamiem riskiem neautorizētai izmantošanai vai atklāšanai, mērķiem, pēc kuriem mēs apstrādājam informāciju, un citiem juridiski saistošiem apsvērumiem.',
    block11:
      'Mēs varam atjaunināt šo Privātuma politiku laikā. Kad mēs to darīsim, mēs publicēs atjaunināto versiju šajā lapā, ja attiecīgās likuma noteikumi nepieprasa citādi.',
    block12:
      'Ja jums ir kādi neatzvērti jautājumi vai bažas par šo Privātuma politiku, lūdzu, sazinieties ar mūsu klientu apkalpošanu. E-pasts:',
    block2: 'Mēs savācam šādu jūsu personīgo informāciju ("Personīgā informācija"):',
    block3:
      'Jūsu sniegtā informācija: Kad Jūs izveidojat kontu, lai izmantotu mūsu pakalpojumus, vai sazināties ar mums, mēs savāc personisko informāciju šādā veidā:',
    block4:
      'Personīgā informācija, kas automātiski saņemta no jūsu pakalpojumu izmantošanas: Kad jūs piekļūstat, izmantojat vai mijiedarboties ar pakalpojumiem, mēs saņemam šādu informāciju par jūsu piekļuvi, izmantošanu vai mijiedarbību ("Tehniskā informācija"):',
    block5: 'Mēs varam izmantot personīgo informāciju šādiem mērķiem:',
    block6:
      'Kopsavilkums vai personu datiem neatbilstoša informācija: Mēs varam agregēt vai personifikuot personālos datus, lai novērstu to atkārtotu izmantošanu identifikācijas mērķiem, un izmantot šādu informāciju, lai analizētu mūsu pakalpojumu efektivitāti, uzlabotu un pievienotu pakalpojumu funkcijas, veiktu pētījumus un citiem līdzīgiem mērķiem. Turklāt mēs varam analizēt mūsu pakalpojumu lietotāju vispārējo uzvedību un īpašības, kā arī dalīties ar agregētā informāciju ar trešajām personām, publicēt šādu agregēto informāciju vai padarīt to vispārpieejamu. Mēs varam savākt agregēto informāciju caur pakalpojumiem, caur sīkdatnēm un ar citiem līdzīgos līdzekļiem, kas aprakstīti šajā Privātuma politikā. Mēs uzturēsim un izmantosim personifikuotu informāciju anonīmos vai personifikuotos formātos, un mēs necenšēsim atkal identificēt šādu informāciju, ja vien tas nav prasīts likumīgi.',
    block7:
      'Noteiktos gadījumos mēs varam nodot jūsu personīgo informāciju trešajām personām bez papildu paziņojuma jums, ja nepieciešams saskaņā ar likumu:',
    block8:
      'Atkarībā no jūsu ģeogrāfiskās atrašanās vietas, personas Eiropas Ekonomiskajā reģionā, Lielbritānijā un visā pasaulē var būt noteiktas statutāras tiesības attiecībā uz viņu personas datiem. Piemēram, jums var būt tiesības: ',
    block9:
      'Pakalpojums var saturēt saites uz citiem vietnēm, kuras nav pārvaldītas vai kontrolētas Noam, tostarp sociālo mediju pakalpojumus ("Trešo pušu vietnes"). Informācija, kuru jūs dalaties ar Trešo pušu vietnēm, tiks regulēta ar konkrētiem Trešo pušu vietņu privātuma politiku un pakalpojumu noteikumiem, nevis ar šo Privātuma politiku. Mēs sniedzam šīs saites ērtības labad un neuzsveram, ka atbalstām vai pārskatījām šīs vietnes. Lūdzu, sazinieties ar Trešo pušu vietnēm tieši, lai iegūtu informāciju par to privātuma politiku un noteikumiem.',
    subBlock1:
      'Konta informācija: Kad izveidojat kontu mūsu platformā, mēs koleģējam kontam saistītu informāciju, tostarp jūsu vārdu, kontaktinformāciju, konta pierakstīšanās datus, maksājumu kartes informāciju un darījumu vēsturi ("Konta informācija").',
    subBlock10: 'Pakalpojumu nodrošināšana, pārvaldība, uzturēšana un/vai analīze;',
    subBlock11: 'Komunikācija ar tevi',
    subBlock12: 'Jaunu produktu un pakalpojumu izstrāde;',
    subBlock13:
      'Novēršana krāpšanas, noziedzīgās darbības vai nepareiza izmantošanas mūsu pakalpojumu, kā arī aizsardzība mūsu IT sistēmu, arhitektūras un tīklu drošības;',
    subBlock14: 'Vērtību pārsūtīšanas veikšana;',
    subBlock15:
      'Iepildot juridiskās pienākumus un juridiskos procesus, aizsargājot mūsu tiesības, privātumu, drošību vai īpašumu, kā arī tiem, kas pieder mūsu filiāliem, jums vai citiem trešajiem personām.',
    subBlock16:
      'Tiekotāji un pakalpojumu sniedzēji: Lai palīdzētu mums piepildīt uzņēmuma operatīvas vajadzības un veikt noteiktus pakalpojumus un funkcijas, mēs varam nodot personisko informāciju tiekotājiem un pakalpojumu sniedzējiem, tostarp hostingu pakalpojumu sniedzējiem, mākoņa pakalpojumu sniedzējiem un citiem informācijas tehnoloģiju pakalpojumu sniedzējiem, e-pasta komunikācijas programmatūrai un tīmekļa analītikas pakalpojumu sniedzējiem utt. Šie partneri piekļūs, apstrādās vai glabās personisko informāciju tikai pēc mūsu norādījumiem, veicot savas pienākumus mums.',
    subBlock17:
      'Uzņēmumu pārnēsāšanas: Ja mēs iesaistīsimies stratēģiskajos darījumos, reorganizācijās, bankrotos, bankrota pārņemšanās vai pakalpojumu pāreju uz citu sniedzēju (kopā sauktos par "Darījumiem"), jūsu personīgā informācija un cita informācija var tikt sadalīta ar darījumu partneriem un citiem dalībniekiem, kas palīdz Darījumos during due diligence, un pārnēsāta kā Darījumu sastāvdaļa kopā ar citiem aktīviem uzņēmumam-pavildu vai附属uzņēmumam.',
    subBlock18:
      'Juridiskie prasības: Mēs varam dalīties ar jūsu personīgo informāciju ar valdības iestādēm, nozares kolēģiem vai citiem trešajām personām, tostarp ar informāciju par jūsu mijiedarbību ar mūsu pakalpojumiem: (1) ja to prasīt likums vai ja mēs uzskatām, ka šāda darbība ir nepieciešama, lai ievērotu juridiskās pienākumus; (2) lai aizsargātu un defendētu mūsu tiesības vai īpašumu; (3) ja mēs vienpusēji nosakām, ka ir pārkāpts mūsu noteikumi, politikas vai likumi; (4) lai uztvertu vai novērstu krāpšanu vai citas nelikumīgas darbības; (5) lai aizsargātu mūsu produktus, darbiniekus, lietotājus vai sabiedrisko drošību, drošību, integritāti; vai (6) lai aizstāvētos pret juridisko atbildību.',
    subBlock19:
      'Piekļūstiet savai personīgajai informācijai un informācijai par to, kā tā tiek apstrādāta.',
    subBlock2:
      'Kad izmantojat mūsu pakalpojumus, mēs savācam personīgo informāciju no jūsu ievades datiem, augšupielādētajiem failiem vai mums sniegtajiem atsauksmēm ("Saturs").',
    subBlock20: 'Pieprasiet savu personīgo informāciju dzēst no mūsu reģistriem.',
    subBlock21: 'Korektējiet vai atjauniniet savu personīgo informāciju.',
    subBlock22: 'Pārsūtiet savu personīgo informāciju trešajai personai (datu prenosamība).',
    subBlock23: 'Ierobežojiet, kā mēs apstrādājam jūsu personas dati.',
    subBlock24:
      'Atcelt savu piekrišanu — tur, kur mēs balstāmies uz piekrišanu kā juridisku pamatu datu apstrādei, jūs varat atcelt savu piekrišanu jebkurā laikā.',
    subBlock25: 'Protestēt pret to, kā mēs apstrādājam jūsu personālo informāciju.',
    subBlock26: 'Mūsu pakalpojumu uzlabošana un pētījumu veikšana;',
    subBlock3:
      'Komunikācijas informācija: Ja jūs nosūtāt mums ziņas, mēs koleģēs jūsu vārdu, kontaktinformāciju un jūsu ziņu saturu ("Komunikācijas informācija").',
    subBlock4:
      'Sociālo mediju informācija: Mums ir lapas sociālo mediju vietnēs, piemēram, Instagram, Facebook, Medium, Twitter, YouTube un LinkedIn. Kad jūs mijiedarboties ar mūsu sociālo mediju lapām, mēs savāc personisko informāciju, kuru jūs izvēlaties mums nodot, piemēram, jūsu kontaktinformāciju ("Sociāla informācija"). Turklāt uzņēmumi, kas uztur mūsu sociālo mediju lapas, var mums nodot agregētu informāciju un analīzi par mūsu sociālo mediju aktivitātēm.',
    subBlock5:
      'Logu dati: Informācija, kas automātiski nosūtīta no jūsu pārlūkprogrammas, izmantojot mūsu pakalpojumus. Logu dati ietver jūsu interneta protokola (IP) adresi, pārlūkprogrammas veidu un iestatījumus, jūsu pieprasījumu datumu un laiku, kā arī to, kā jūs mijiedarboties ar mūsu tīmekļa vietni.',
    subBlock6:
      'Lietojuma dati: Mēs varam automātiski savākt informāciju par jūsu pakalpojuma izmantošanu, piemēram, saturu tipiem, kurus jūs skatāties vai ar kuriem mijiedarboties, funkcijām, kuras jūs izmantojat, darbībām, kuras veicat, kā arī jūsu laika joslu, valsti, piekļuves datumu un laiku, lietotāja aģentu un versiju, datora vai mobilā ierīces tipu un jūsu datora savienojumu.',
    subBlock7:
      'Ierīces informācija: Tas ietver ierīces nosaukumu, operētājsistēmu, ierīces identifikatoru un izmantoto pārlūkprogrammu. Savāktā informācija var atšķirties atkarībā no izmantotās ierīces veida un tās iestatījumiem.',
    subBlock8:
      'Sīkdatnes: Mēs izmantojam sīkdatnes, lai darbina un pārvaldītu mūsu pakalpojumus un uzlabotu jūsu pieredzi. "Sīkdatne" ir informācija, ko jūs apmeklētais vietnes nosūta uz jūsu pārlūkprogrammu. Jūs varat iestatīt pārlūkprogrammu, lai tā pieņemtu visas sīkdatnes, noraidītu visas sīkdatnes vai paziņotu, kad tiek piedāvāta sīkdatne, lai jūs katru reizi varētu izlemt, vai to pieņemt. Tomēr sīkdatņu noraidīšana var novērst jums lietot vai negatīvi ietekmēt noteiktu vietnes daļu vai funkciju attēlojumu vai darbību. Plašāku informāciju par sīkdatnēm lūdzu apmeklējiet All About Cookies.',
    subBlock9:
      'Analītika: Mēs varam izmantot dažādas tiešsaistes analītikas produktus, kas izmanto sīkdatnes, lai palīdzētu mums analizēt, kā lietotāji izmanto mūsu pakalpojumus, un uzlabotu jūsu pieredzi, izmantojot pakalpojumus.',
    subTitle1: 'Mēs savācam personīgo informāciju',
    subTitle2: 'Kā mēs izmantojam personīgo informāciju',
    subTitle3: 'Personas datu atklāšana',
    subTitle4: 'Jūsu tiesības',
    subTitle5: 'Saites uz citiem vietnēm',
    subTitle6: 'Informācijas drošība un saglabāšana',
    subTitle7: 'Privātuma politikas modificēšana',
    subTitle8: 'Kā sazināties ar mums',
    title: 'Privātuma politika',
    updateTime: 'Atjaunināts: 15. marts 2024',
  },
  privacyCollectionPanel: {
    acceptBtn: 'Pieņemt visu',
    text: 'Lai uzlabotu jūsu pieredzi, mēs izmantojam sīkdatnes, lai personalizētu saturu un pakalpojumus.',
    title: 'Šī vietne izmanto sīkdatnes',
  },
  slogen: 'Vienkāršākais AI palīgs',
  stripe: {
    contact: 'Sazinieties ar mums, nosūtot e-pastu uz contact@noam.tools, ar jebkuru jautājumu!',
    fail: {
      btn: 'Mēģināt vēlreiz',
      text1: 'Mēs nevarējām apstrādāt jūsu maksājumu.',
      text2: 'Pārbaudiet savienojumu un mēģiniet vēlreiz.',
      title: 'Maksājums neizdevās',
    },
    succ: { btn: 'Ejam', text1: 'Laipni lūdzam Noam', text2: 'sāksim!', title: 'Apsveicam' },
  },
  terms: {
    block1: 'Paldies, ka izmantojāt Noam!',
    block10:
      '(a) Maksas un rēķinu izrakstīšana. Jūs apmaksāt visas maksas ("Maksas") saskaņā ar cenu un nosacījumiem attiecīgajā cena lapā vai kādas ir noslēgtas rakstiski starp mums. Mēs saglabājam tiesības labot cenu kļūdas vai kļūdas, pat ja esam izrakstījuši rēķinus vai saņēmuši apmaksu. Jūs nododat pilnu un precīzu rēķinu informāciju, tostarp derīgu un autorizētu apmaksas metodi. Mēs apmaksāsim jūsu apmaksas metodi periodiski, kā tas ir noslēgts, bet mēs varam racionāli mainīt rēķinu datumu. Jūs autorizējat Noam, tās filiālēs un trešo pušu apmaksas procesoru apmaksāt jūsu apmaksas metodi. Ja jūsu apmaksa neizdodas, mēs jums nosūtīsim rakstisku paziņojumu un varam apturēt piekļuvi Pakalpojumam līdz apmaksas saņemšanai. Izņemot gadījumus, kas citādi ir noteikti šajā līgumā, apmaksas nav atgriezeniskas.',
    block11:
      '(b) Nodokļi. Ja nav precīzi norādīts citādi, maksas neatņem jebkādus federālus, štata, lokālus un ārvalstu nodokļus, nodevas un līdzīgas izmaksas ("Nodokļi"). Jūs esat atbildīgs par visiem ar jūsu pirkumiem saistītajiem nodokļiem, izņemot nodokļus, kas balstīti uz mūsu tīrās ienākumiem, par kuriem mēs jums iesniegsim rēķinu. Jūs piekrītat nekavējoties samaksāt šādus nodokļus un nodrošināt mums juridiski derīgas privātuma paziņojumus, kā arī iegūt nepieciešamos piekrišanas datus apstrādei, un jūs garantējat mums, ka apstrādājat šādus datus saskaņā ar piemērotā likumu.',
    block12:
      '(c) Cenu izmaiņas. Mēs varam mainīt savas cenas, paziņojot jums caur jūsu kontu un/vai mūsu tīmekļa vietni. Cenu paaugstināšanas stājas spēkā tūlīt pēc publicēšanas. Jebkuras cenu izmaiņas attieksies uz jūsu konta maksājumiem pēc izmaiņas stāšanās spēkā datuma.',
    block13:
      '(d) Strīdi un neprompti maksājumi. Ja vēlaties apstrīdēt kādas naudas summas vai nodokļus, lūdzu, sazinieties ar contact@noam.tools trīsdesmit (30) dienu laikā no rēķina izdades datuma.',
    block14:
      '(e) Bezmaksas izmantošana. Jūs nevarat izveidot vairākas kontus, lai iegūtu bezmaksas kredītus. Ja mēs nosakām, ka jūs neizmanto bezmaksas kredītus godprātībā, mēs varam jums rēķināt par standarta maksām vai pārtraukt piekļuvi pakalpojumam.',
    block15:
      '(a) Konfidencialitāte. Jums var būt piekļuve Noam konfidencionālajai informācijai. Konfidencionālo informāciju varat izmantot tikai tādā veidā, kā tas ir atļauts saskaņā ar šīm nosacījumiem, un vienīgi pakalpojuma izmantošanas mērķiem. Konfidencionālo informāciju nedrīkat atklāt nevienam trešajam personai, un jums jāaizsargā konfidencionāla informācija ne mazāk uzmanīgi, nekā jūs aizsargājat savu līdzīgu konfidencionālo informāciju, vismaz ar racionālu uzmanību. Konfidencionāla informācija ir nepublicēta informācija, ko Noam ir uzsvēris kā konfidencionālu, vai kāda, kas pēc apstākļiem racionāli jāuzskata par konfidencionālu, tostarp programmatūra, specifikācijas un cita nepublicēta uzņēmējdarbības informācija. Konfidencionālo informāciju neattiecas uz informāciju, kas: (1) kļūst par vispārpieejamu publikai bez jūsu kļūdas; (2) jums bija pieejama bez jebkādiem konfidencialitātes pienākumiem pirms tā saņemšanas saskaņā ar šīm nosacījumiem; (3) jums ir likumīgi atklāta trešās personas bez jebkādiem konfidencialitātes pienākumiem; vai (4) ir izstrādāta jums neatkarīgi, neizmantojot konfidencionālo informāciju. Konfidencionālo informāciju varat atklāt, ja to prasīt likums, tiesa vai cits valdības rīks, taču jums ir jānodod Noam iepriekšēja rakstiska paziņojuma ar racionālu veidu un, pēc iespējas, jāpieliek racionāli pūliņi, lai ierobežotu atklāšanas diapazonu, tostarp palīdzot mums apstādāt atklāšanas pieprasījumus.',
    block16:
      '(b) Drošība. Jums ir jāievieš racionāli un piemēroti pasākumi, lai palīdzētu aizsargāt piekļuvi un izmantošanu Pakalpojumam. Ja Jūs atklājiet kādas sāucējas vai pārkāpumus, kas saistīti ar Jūsu Pakalpojuma izmantošanu, Jums ir nekavējoties jāsaista ar Noamu un jānodod sāucējuma vai pārkāpuma detaļas.',
    block17:
      '((c) Personas datu apstrāde. Ja jūs izmantojat pakalpojumu, lai apstrādātu personas datus, jums ir jānodrošina juridiski pietiekami privātuma paziņojumi un jāiegūst nepieciešamie piekriumi šo datu apstrādei, un jūs garantējat mums, ka jūs apstrādājat šos datus saskaņā ar piemērojamo likumu.',
    block18:
      '(a) Beendīšana; Apturēšana. Šie noteikumi stājas spēkā no jūsu pirmās pakalpojuma izmantošanas brīža un paliek spēkā līdz beendīšanai. Jūs varat beigt šos noteikumus jebkurā laikā jebkādēļ, pārtraucot pakalpojuma un saturu izmantošanu. Mēs varam beigt šos noteikumus ar iepriekšēju paziņojumu jebkādēļ. Mēs varam nekavējoties beigt šos noteikumus, jums paziņojot, ja jūs būtiski pārkāpj 2. sadaļu (Izmantošanas prasības), 5. sadaļu (Konfidencialitāte, drošība un datu aizsardzība), 8. sadaļu (Strīdu risināšana) vai 9. sadaļu (Vispārīgi noteikumi), vai ja mūsu attiecības ar jebkuru trešo pušu tehnoloģiju sniedzēju, kas nepieder mūsu kontrolei, mainās, vai kāpēc jāievēro likumi vai valdības pieprasījumi. Mēs varam apturēt jūsu piekļuvi pakalpojumam, ja jūs neievērosit šos noteikumus, vai ja jūsu izmantošana rada drošības risku mums vai jebkurai trešajai pusei, vai ja mēs uzskatām, ka jūsu izmantošana ir krāpīga vai var izpostīt mūs vai jebkuru trešo pušu atbildību.',
    block19:
      '(b) Terminācijas sekas. Pēc terminācijas jūs beigsiet izmantot pakalpojumu un ātri atgriezīsiet vai iznīcināsiet jebkuru konfidenciālo informāciju, kā tas ir norādīts mums. Šo noteikumu noteikumi, kuri pēc savas būtības ir jāpaliek spēkā pēc terminācijas vai termiņa beigšanas, tostarp, bet ne tikai 3. un 5.-9. sadaļas, paliks spēkā.',
    block2:
      'Šie Lietošanas noteikumi attiecas uz jūsu izmantošanu Noam pakalpojumiem, tostarp mūsu lietojumprogrammu programmēšanas interfeisiem, programmatūrai, rīkiem, izstrādātāju pakalpojumiem, datiem, dokumentācijai un tīmekļa vietnei (kopīgi saukti par "Pakalpojumiem"). Izmantojot mūsu Pakalpojumus, jūs piekrītat ievērot šos noteikumus. Mūsu Privātuma politika izskaidro, kā mēs kolektējam un izmanto personīgos datus.',
    block20:
      '(a) Aizsardzība no atbildības. Jūs aizsargāsiet, nodrošināsiet aizsardzību no atbildības un glabāsiet mūs, mūsu filiāles un mūsu darbiniekus bez atbildības pret jebkuru prasību, zaudējumu un izmaksas (ieskaitot advokātu honorāriju), kas rodas no jūsu Saziņas pakalpojuma izmantošanas vai ar to saistītas, tostarp jūsu satura, jūsu ar Saziņas pakalpojumu saistīto produktu vai pakalpojumu izmantošanas, kā arī jūsu pārkāpumu attiecībā uz šīm noteikumiem vai piemērojamo likumu.',
    block21:
      '(b) Atteikšanās no atbildības. Pakalpojums tiek nodrošināts "kā tas ir". Likumā atļautajā apjomā mēs, mūsu filiāli un licencētāji nepieņemam nekādas deklarācijas vai garantijas par pakalpojumu, un nepieņemam nekādas garantijas, tostarp, bet ne tikai, garantijas par tirdzniecības saderību, piemērotību konkrētai nolūkam, apmierinošo kvalitāti, neinfringementu un mierīgu izmantošanu, kā arī jebkādas garantijas, kas izriet no attiecību gaitu vai tirdzniecības lietošanas. Mēs negarantējam, ka pakalpojums būs neatliekams, precīzs vai bez kļūdām, vai ka jebkura saturs būs drošs, nezaudēts vai nemainīts.',
    block22:
      '(c) Atbildības ierobežojums. Neesam, mūsu filiāliem ne arī licencētājiem nav atbildīgi par jebkādiem netiešajiem, nejaušajiem, īpašajiem, sekojošajiem vai sodiem gaitos novērtējamiem zaudējumiem, tostarp peļņas zaudējumiem, reputācijas zaudējumiem, izmantošanas zaudējumiem, datu zaudējumiem vai citiem ne materiāliem zaudējumiem, pat ja mēs esam saņēmuši brīdinājumu par iespējamiem šādiem zaudējumiem. Saskaņā ar šiem nosacījumiem mūsu kopējā atbildība nevirzās pāri to maksām, kuras jūs esat samaksājis Dienestam divpadsmit (12) mēnešos pirms prasības iesniegšanas, vai 100 ASV dolāriem (100 USD), atkarībā no tā, kas ir lielāks. Šajā sadaļā noteiktie ierobežojumi attiecas līdz maksimālajam apjomam, kas atļauts saskaņā ar piemērojamo likumu.',
    block23:
      'Noteikumi un jūsu pakalpojumu izmantošana tiek regulēta ar Amerikas Savienoto Valstu likumiem, izņemot ASV likumu konflikta noteikumus. Jūsu lietotnes izmantošana var būt arī pakļauta citiem lokāliem, štata, nacionālajiem vai starptautiskajiem likumiem. Jebkura juridiskā darbība vai processes, kas saistīts ar šiem noteikumiem, tiks iesniegts tikai Amerikas Savienoto Valstu tiesās, un jūs piekrītat personīgajai jurisdikcijai šīm tiesīm.',
    block24:
      'Parietu attiecības. Noam un jūs esat neatkarīgi pakalpstaji, un neviena puse nav tiesīga pārstāvēt vai saistīt otru pusi, nevis uzņemt pienākumus par otru pusi bez cita puses iepriekšēja rakstiskā piekrišanas.',
    block25:
      '(b) Zīmolu lietošana. Jūs nevarat izmantot Noam vārdu, logotipus vai preču zīmes, kā arī kādu no tās filiāliem, bez mūsu iepriekšēja rakstiskā piekrišanas.',
    block26:
      'Ja kāda no šīm nosacījumiem noteikta disposīcija tiek uzskatīta par nederīgu, nelikumīgu vai neiespējamu izpildīt, pārējās disposīcijas paliks pilnībā spēkā un derīgās.',
    block3:
      'Ja jūs esat jaunāks par 18 gadiem, lai izmantotu pakalpojumu, jums ir jāiegūst piekrišana no vecākiem vai juridiskajiem vadītājiem. Ja jūs izmantojat pakalpojumu citu personu vai entitāti pārstādot, jums ir jābūt autorizētam pieņemt šos noteikumus viņu vārdā. Lai reģistrētu kontu, jums ir jānodod precīza un pilna informācija. Jūs nevarat nodot savas piekļuves akreditācijas datus vai kontu nevienam ārpus savas organizācijas, un jūs esat atbildīgs par visiem darbībām, veiktām, izmantojot savas akreditācijas datus.',
    block4:
      '(a) Pakalpojuma izmantošana. Jūs varat piekļūt Pakalpojumam saskaņā ar šīm nosacījumiem, un mēs jums piešķiram neekskluzīvu tiesību izmantot Pakalpojumu. Izmantojot Pakalpojumu, jūs ievērosit šīs nosacījumus un visas piemērotās likumus. Mēs un mūsu filiāli esam īpašnieki visām tiesībām, nosaukumiem un interesēm Pakalpojumā.',
    block5:
      '(b) Atbalsts. Mēs vēlamies saņemt atbalstu, komentārus, idejas, ieteikumus un uzlabojumus. Ja jūs sniedzat kādu šādu saturu, mēs to varam izmantot bez jebkādām ierobežojumiem un bez kompensācijas jums.',
    block6:
      '(c) ierobežojumi. Jūs nevarat: (1) izmantot pakalpojumu tā, lai tā infrinģētu, neatbilstoši paņemtu vai pārkāptu citu tiesības; (2) veikt atgriezenisko inženieriju, dekompilēt, sadalīt, tulkot vai citādi mēģināt atklāt avota kodu vai pamatkomponentes pakalpojuma modeļiem, algoritmiem un sistēmām (izņemot gadījumus, ja šie ierobežojumi ir aizliegti ar piemērojamo likumu); (3) izmantot pakalpojuma izvadi, lai izstrādātu modeļus, kas konkurē ar Noam; (4) iegūt datus vai izvadi no pakalpojuma, izmantojot kādas automatizētas vai programmēšanas metodes, ja tas nav atļauts caur API, tostarp izmantojot skrēpingu, tīmekļa plaukšanas vai tīmekļa datu iegūšanu; (5) attēlot pakalpojuma izvadi kā mākslīgi ģenerētu, ja tā nav, vai citādi pārkāpt mūsu lietošanas politiku; (6) iegādāties, pārdot vai pārnest API atslēgas bez mūsu iepriekšēja piekrišanas; vai (7) sniegt mums jebkuru personas datus bērniem, kuriem ir mazāk par 13 gadiem, vai piemērotam digitālās piekrišanas vecumam. Jūs ievērosiet visus ātruma ierobežojumus un citas prasības mūsu dokumentācijā.',
    block7:
      '(d) Trešo pušu pakalpojumi. Jebkura trešo pušu programmatūra, pakalpojumi vai citi ar pakalpojumu saistītie produkti tiek regulēti ar viņu pašu noteikumiem, un mēs neatbildam par trešo pušu produktiem.',
    block8:
      '(a) Jūsu saturs. Jūs varat sniegt ievadi ("Ievade") pakalpojumam un saņemt izvadi ("Izvade"), kas ģenerēta un atgriezta pamatojoties uz Ievadi (kopā saukts par "Saturs"). Starp pusiem, un tādā apmērā, cik to ļauj piemērojamā likumība, jūs esat īpašnieks visiem Ievadiem. Noam var izmantot Saturu, lai nodrošinātu un uzturētu Pakalpojumu, ievērot piemērojamo likumību un vērst spēku mūsu politiku. Jūs esat atbildīgs par Saturu, tostarp nodrošinot, ka tas neatkāpj no piemērojamās likumības vai šīm nosacījumiem.',
    block9:
      '(b) Precizitāte. Mākslīgā intelekta un mašīnmācīšanās ir strauji attīstīgos pētniecības lauki. Mēs nepārtraukti cenšamies uzlabot savu servisu, lai tas kļūtu precīzāks, uzticamāks, drošāks un noderīgāks. Ņemot vērā mašīnmācīšanās probabilistisko naturu, servisa izmantošana dažos gadījumos var izraisīt nepareizus rezultātus, kuri ne vienmēr precīzi atspoguļo reālas personas, vietas vai faktus. Jums jānovērtē jebkura izvades precizitāte atbilstoši jūsu lietošanas gadījumam, tostarp veicot manuālu pārskatīšanu.',
    subTitle1: 'Reģistrācija un piekļuve',
    subTitle10: 'Atsevišķā spēkā esošam',
    subTitle2: 'Lietojuma prasības',
    subTitle3: 'Saturs',
    subTitle4: 'Maksas un maksājumi',
    subTitle5: 'Konfidencialitāte, Drošība un Datu Aizsardzība',
    subTitle6: 'Termiņš un beigas',
    subTitle7: 'Aizsardzība no atbildības; Atteikšanās no atbildības; Atbildības ierobežojums',
    subTitle8: 'Tiesību regulējums un jurisdikcija',
    subTitle9: 'Vispārējie noteikumi',
    title: 'Pakalpojumu noteikumi',
    updateTime: 'Atjaunināts: 15. marts 2024',
  },
  trialModal: {
    btn: 'Sāciet tagad (tikai 0,99 USD)',
    chat: 'ChatPDF',
    desc1: 'Pēc jūsu izmēģinājuma perioda jums tiks rēķināts gada maksa 180 dolāri',
    desc2: 'Atcelt jebkurā laikā',
    focus: 'Konsentrēšanās',
    hover: 'Pārvietojošā tulkojuma',
    image: 'Attēla tulkošana',
    installBtn: 'Instalējiet tagad, lai saņemtu savu dāvanu',
    memo: 'Izlase pārvaldība',
    pdf: 'PDF paralēlā tulkošana',
    realtime: 'Tiešsaistes tulkojums',
    select: 'Vārdu izvēles tulkojums',
    title: 'Laipni lūgšanas dāvana',
    trialText: '7-dienu izmēģinājums',
    video: 'Video tulkojums',
    videoSummary: 'Video kopsavilkums',
    web: 'Paralēlā tulkošana',
    webSummary: 'Tīmekļa kopsavilkums',
  },
  upgradeModal: {
    btn: 'Atjauniniet tagad',
    chat: {
      free: 'Jūs esat sasnieguši ChatPDF limits',
      pro: 'Jūs esat sasnieguši šī mēneša ChatPDF limits',
    },
    contactStr:
      'Lūdzu, gaidiet nākamo atiestatīšanu vai sazinieties ar mums caur contact@noam.tools.',
    limitAlertStr: 'Jūs esat sasniedzis bezmaksas plāna limitu. Atjauniniet, lai turpinātu.',
    more: 'Skatīt plānus',
    pageLimit: { free: 'Jūs esat sasnieguši PDF lapu limitu' },
    title: 'Atgādinājums',
    upgradeAlertStr: 'Jūs esat sasnieguši bezmaksas plāna limits. Atjauniniet, lai turpinātu.',
    upload: {
      free: 'Jūs esat sasniedzis savu PDF tulkošanas limits',
      pro: 'Jūs esat sasnieguši šī mēneša PDF tulkošanas limits',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'Piesakies tagad',
      label: 'Jauno lietotāju priekšrocības:',
      remain: 'Atlikuši tikai 30',
      text: 'Tikai 100 vietas pieejamas! Iegūstiet savu tagad!',
    },
  },
  aiPdfTranslator: {
    title: 'Bezmaksas AI PDF tulks: Tulkot PDF ar salīdzināšanu jebkurā valodā',
    desc: 'Vienkārši tulkot PDF failus uz jebkuru valodu, izmantojot AI. Salīdziniet oriģinālo un tulkotu tekstu blakus viens otrai, ātri un bezmaksas.',
    keywords: 'GPT-4、AI Palīgs、Tulkojums、Kopsavilkums、Fokus、ChatPDF、Notiņa、efektivitāte',
    sourceToTarget: {
      title: 'Bezmaksas PDF tulkošanas rīks: tulkot {{source}} uz {{target}} bez maksas',
      desc: 'Pārveidojiet savus PDF failus no jebkuras avota valodas uz savu vēlamo valodu bezmaksas. ātra, precīza un droša PDF tulkošana, ko nodrošina uzlabota AI.',
    },
    headerIntroduce: {
      title: 'Noam: vairāk nekā tikai tiešsaistes tulkošana',
      introduce1: {
        title: 'Noam · PDF lasītājs',
        desc: '✨Pārskatāma tulkošana + AI jautājumi un atbildes. Ātri un precīzi tulkojiet PDF failus uz savu mērķvalodu. Brīvi uzdodiet jautājumus par saturu, lai iegūtu dziļāku izpratni par jūsu PDF failiem.',
      },
      introduce2: {
        title: 'Noam · Kustuliskais tulkojums paplašinājums',
        desc: '👏Izmēģiniet visus savus tīmekļa lapas tulkošanas vajadzības:',
        detail1: { title: 'Tīmekļa lapas tulkošana:', desc: 'Sānu līnijā divvalodu skats' },
        detail2: {
          title: 'Vārda tulkojums:',
          desc: 'Vienkārša pārlūkprogrammatūra ar vienu klikšķi',
        },
        detail3: { title: 'Tiešsaistes tulkošana:', desc: 'Tulkojiet vārdus vai teikumus tūlīt.' },
        detail4: { title: 'Attēla tulkošana:', desc: 'Aizstāt attēlus ar tulkotajiem.' },
        detail5: {
          title: 'Video tulkojums:',
          desc: 'Dvalngu subtitri labākai skatīšanās pieredzei.',
        },
        footer:
          'Izmantojiet vairāk ar AI atbalstītas lasīšanas funkcijas, lai veiktu inteliģentāku tulkošanu!',
      },
    },
    subtitle: 'PDF tulkot online bez maksas',
    introduce: {
      module1: {
        detail1: {
          title: 'Reāllaika blakus PDF tulkošana',
          desc1:
            'Tieši parādīt oriģinālo un tulkotu saturu sinhronizētā blakus viena otrai izkārtojuma',
          desc2: 'Vienkārši salīdziniet abas versijas ar sinhronizētu ritināšanu',
          desc3:
            'Saglabājiet identisku formatējumu, lai nodrošinātu konsistentu lasīšanas pieredzi',
        },
        detail2: {
          title: 'Precīza saturu sinhronizācija un verifikācija',
          desc1:
            'Ideāla sinhronizācija starp sākotnējo un tulkotu tekstu, lai pārbaude būtu vieglāka',
          desc2: 'Katrs saturssegmenti precīzi sakrīt abās versijās',
          desc3:
            'Ātri atklājiet un novēršiet tulkošanas neatbilstības, lai iegūtu uzticamus rezultātus',
        },
      },
      module2: {
        detail1: {
          title: 'Vairākas uzlabotas AI modeļi precīzajai tulkošanai',
          desc1: 'Izvēlieties no vadošajiem AI modeliem, lai atbilstu jūsu tulkošanas prasībām',
          desc2: 'Veidot optimālos rezultātus dažādiem dokumentu tipiem un nozarēm',
          desc3: 'Elastīgas modeļa opcijas nodrošina pielāgotas risinājumus katram scenārijam',
        },
        detail2: {
          title: 'Uzlabota AI tulkojums katram saturam tipam',
          desc1:
            'Mūsu spēcīgā AI modelis nodrošina augstu precizitāti un dabiskas valodas sapratni',
          desc2: 'Vienkārši apstrādā tehniskos, akadēmiskos un radošos dokumentus',
          desc3: 'Sniedz uzticamus rezultātus visiem jūsu tulkošanas vajadzībām',
          desc4: 'Inteliģenta adaptācija dažādiem saturu tipiem optimālai darbībai',
        },
      },
      module3: {
        detail1: {
          title: 'Inteliģenta dokumentu mijiedarbība',
          desc1:
            'Vienkārši sarunāieties ar saviem PDF un prezentāciju failiem, izmantojot uzlabotu AI',
          desc2: 'Tieši jautājiet par dokumenta saturu un saņemiet precīzas atbildes',
          desc3: 'Ātri ģenerēt īsākus kopsavilkumus garām dokumentiem',
        },
        detail2: {
          title: 'Detaļiska satursanalīze un bezvainojoša integrācija',
          desc1:
            'Izgūstiet galveno informāciju un analizējiet sarežģītu datus, izmantojot AI vadītu sapratni',
          desc2: 'Iegūstiet ieskatu tehniskajos, akadēmiskajos vai radošajos materiālos',
          desc3:
            'Nevainojami integrējas ar mūsu PDF tulkotāju, nodrošinot pilnīgu dokumentu pārvaldības risinājumu',
        },
      },
      module4: {
        detail1: {
          title: 'Vairāk nekā PDF tulkošana: Visu vienā vietā tīmekļa lapu tulkošanas risinājums',
          desc: 'Atklājiet mūsu spēcīgo blakus blakus tulkošanas paplašinājumu, kas izstrādāts katrai tiešsaistes lasīšanas situācijai.',
          desc1:
            'Tīmekļa lapas tulkojums: Izmantojiet divvalodu saturu ar sinhronizētu blakus blakus skatījumu',
          desc2: 'Vārda tulkojums: Tūlko izceltos vārdus uzreiz ar vienu klikšķi',
          desc3:
            'Tiešsaistes tulkošana: Tulkot jebkuru tekstu vai teikumu uz vietas, lai ātri saprastu',
          desc4: 'Attēlu tulkošana: Automātiski aizstāt sākotnējus attēlus ar tulkotām versijām',
          desc5: 'Video tulkojums: Skatieties video ar divju valodu subtitriem uzlabotai pieredzei',
        },
      },
    },
    question: {
      title: 'Bieži uzdotie jautājumi',
      answer1: {
        title: 'Vai Noam PDF Translator ir bezmaksas lietojams PDF tulkošanai?',
        content:
          'Jā, jūs varat tulkot PDF failus bezmaksas ar Sider PDF Tulkotāju! Mēs piedāvājam bezmaksas kvotu 5000 tokenu, kas ir pietiekams, lai tulkotu lielāko daļu PDF dokumentu, kas parasti sastopami tirgū. Ja jums ir jā tulko lielāki faili vai jums nepieciešamas papildu funkcijas, jūs varat izvēlēties atjaunināt uz mūsu premium plāniem, lai iegūtu vēl vairāk iespēju.',
      },
      answer2: {
        title: 'Cik precīzs ir Noam PDF tulks?',
        content:
          'Noam PDF tulks sniedz ļoti precīzas tulkojumus, izmantojot paaugstinātu AI tehnoloģiju un dziļi saprotot jūsu dokumentu kontekstu. Lai gan nekas automatizēts tulkojums nav bezkļūdīgs, mūsu blakus rādītais displejs ļauj viegli pārskatīt un precizēt katru tulkojumu, nodrošinot, ka galīgā rezultāts atbilst jūsu kvalitātes cerībām. Izmēģiniet uzticamu un precīzu PDF tulkošanu ar Noam.',
      },
      answer3: {
        title: 'Vai es varu tulkot skenētus PDF failus?',
        content:
          'Jā, jūs varat tulkot skenētus PDF failus izmantojot mūsu iekļauto OCR (Optiskā rakstzīmju atpazīšana) tehnoloģiju. Mūsu sistēma automātiski izvilk tekstu no skenētajiem dokumentiem un attēlu pamatotos PDF failus, pēc tam tulko saturu jums. Tas nodrošina, ka pat nedēļējami vai tikai ar attēliem PDF faili var tikt precīzi tulkoti.',
      },
      answer4: {
        title: 'Cik ilgi trāuc tulkošana?',
        content:
          'Tulkojums ir ātrs un efektīvs — lielākā daļa dokumentu tiek apstrādāta no dažiem sekundēm līdz dažiem minūtēm, atkarībā no to garuma un sarežģītības. Piemēram, standarta 10 lapu PDF parasti tulkojās mazāk kā 2 minūtes. Baidieties ar ātru izpildi visiem jūsu dokumentu tulkošanas vajadzībām!',
      },
      answer5: {
        title: 'Vai es varu saglabāt blakusīgo skatu lasīšanai?',
        content:
          'Jā, jūs vienmēr varat lasīt savus dokumentus blakus vienam otraim. Šis izkārtojums ļauj viegli salīdzināt oriģinālo un tulkotu saturu, nodrošinot gludu un efektīvu lasīšanas pieredzi.',
      },
    },
    freeTrial: 'Bez maksas izmēģinājums',
    toLanguage: { title: 'PDF AI tulkošanas pāri', item: '{{mērķis}}' },
  },
  aiPdfTranslate: {
    header: {
      features: 'Funkcijas',
      faq: 'BUJ',
      pricing: 'Cenu noteikšana',
      button: 'Tulkot tagad',
      blog: 'Blogs',
    },
    hero: {
      upload: {
        title: 'Augšupielādējiet savu PDF failu',
        max: 'Maks',
        desc: 'vai velciet un nometiet',
        highlight: 'Noklikšķiniet, lai pārlūkotu',
      },
      to: 'uz',
      pill: 'AI-pilnvarots PDF tulks',
      title: 'Bez maksas PDF tulks',
      model: 'GPT-4 un Claude',
      support: 'OCR atbalsts',
      desc: 'Tiešsaistes, precīzas tulkojumi, kas saglabā sākotnējo izkārtojumu. Noam AI atbalsta OCR un blakus vienā skatā skatījumus.',
      translated: 'Tulkots Noam',
      free: 'Bezmaksas izmēģinājums',
      complete: 'Tulkojums pabeigts',
    },
    ticker: {
      pdf: 'PDF tulkojums',
      ocr: 'OCR tehnoloģija',
      multi: 'Vairākvalodu',
      format: 'Formāta saglabāšana',
      chat: 'Sarunas ar PDF',
      side: 'Pāri pa pāri',
      secure: 'Drošs un privāts',
      web: 'Tīmekļa tulkojums',
    },
    comparison: {
      bad: {
        title: 'Standarta tulkojums',
        head: 'Zaudēta formatēšana un konteksts',
        text1: 'Kļūda: Izmēģinājums bojāts. Attēli nepareizi novietoti.',
        text2: 'Teksts pārklājas un fonti nav konsistentīgi. Grūti lasāms un neprofesionāls...',
      },
      dump: { title: 'Vienkārša teksta izvade' },
      good: {
        title: 'Noam AI Tulkošana',
        sub: 'Ideāla Formatēšana, Kontekstjestāvīga',
        tag: 'Perfekts Rezultāts',
      },
      title: 'Kāpēc izvēlēties Noam AI?',
      desc: 'Presti no cenšēšanās ar kopēšanas-ielīmēšanas tulkojumu. Paredziet atšķirību starp standarta rīkiem un mūsu AI vadīto kontekstā jēgpilnu tulkojumu.',
    },
    showcase: {
      kicker: 'ATBalstītie dokumenti',
      title1: 'Jebkurš dokuments',
      title2: 'Jebkura valoda',
      carousel1: 'Māksla',
      carousel3: 'Akadēmiskais žurnāls',
      carousel2: 'Arhitektūra',
      note: 'Vienkārši apstrādājiet tehniskos, akadēmiskos un radošos dokumentus.',
      carousel4: 'Medicīna',
      carousel5: 'Finanses',
      carousel6: 'Likums',
      carousel8: 'Politika',
      carousel7: 'Līgums',
    },
    features: {
      big: {
        title: 'Uzlabotie AI modeļi (GPT-4, Claude)',
        desc: 'Izvēlieties no vadošajiem AI modeliem, lai atbilstu jūsu tulkošanas prasībām. Nodrošiniet optimālos rezultātus dažādu dokumentu tipiem.',
      },
      grid1: {
        title: 'OCR atbalsts',
        desc: 'Uzreiz izvilciet un tulkojiet tekstu no skenētajiem PDF failiem un attēliem.',
      },
      grid2: {
        title: 'Augstrezolūcijas eksports',
        desc: 'Lejupielādējiet savus tulkotos dokumentus PDF formātā ar oriģinālo izkārtojumu.',
      },
      grid3: {
        title: 'Salīdzinājums blakus blakus',
        desc: 'Sinhronizēts ritināšana, lai salīdzinātu oriģinālo un tulkotu tekstu.',
      },
      title1: 'Vairāk nekā tikai tulkošana',
      title2: 'Tā ir revolūcija',
      line1: 'Tehniskais darbs.pdf',
      line3: 'Modelis: GPT-4o (Augsta precizitāte)',
      line2: 'Valodas detekcija: angļu valoda...',
      line4: 'Tulkojums pabeigts (99% precizitāte)',
    },
    testimonials: {
      review1: {
        role: 'Mācējs',
        content:
          'Noam AI ietaupīja man stundas, pēctiekot akadēmisko darbiem tulkot. Kājienes blakus skats ir izņēmīgi noderīgs, lai pārbaudītu tehniskos termiņus.',
      },
      review2: {
        role: 'Globālais mārketējs',
        content:
          'Labākais PDF tulks, kuru es esmu izmantojis. Tas perfektīgi saglabā sākotnējo formatēšanu, kas ir ļoti svarīgi mūsu mārketinģa prezentācijām.',
      },
      review3: {
        role: 'Juridiskais konsultants',
        content:
          'Precīzs un ātrs. Esmu to lietojis līgumu tulkojumiem, un OCR funkcija skenētu dokumentu apstrādei darbojas bez problēmām.',
      },
      kicker: 'Mīļots lietotājiem',
      title: 'Ko saka mūsu lietotāji',
    },
    cta: {
      title: 'Gatavs pārvarēt valodas barjeras?',
      hint: '',
      desc: 'Pievienojieties 10 000+ lietotājiem un sāciet tulkot savus dokumentus ar Noam AI šodien.',
      button: 'Sāciet tulkot bez maksas',
    },
    languagePairs: {
      title: 'Angļu valodas PDF AI tulkošanas pāri',
      desc: 'Populārās tulkošanas virzieni, kurus atbalsta Noam AI',
    },
    footer: {
      about: 'Par mums',
      privacy: 'Privātuma politika',
      contact: 'Sazinieties ar atbalstu',
    },
  },
}

export default TRANSLATION
